import React from 'react';
import { Container, ContainerProps, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import GlobalStyles from '@mui/material/GlobalStyles';

export type BoxContainerProps = Pick<ContainerProps, 'maxWidth'> & {
  variant?: 'regular' | 'dense';
  overflow?: boolean;
  frame?: boolean;
  children?: React.ReactNode;
};

const useStyles = makeStyles()((theme: any) => {
  const smDown = theme.breakpoints.down('md');
  const mdUp = theme.breakpoints.up('md');
  return {
    root: {
      [smDown]: {
        maxWidth: '100%',
        background: theme.palette.background.paper,
        height: `calc(100% - ${theme.mixins.toolbar.minHeight}px)`,
        '&.dense': {
          height: `calc(100% - ${theme.mixins.appBar.minHeight}px)`,
        },
        '&.overflow': {
          height: 'initial',
        },
        '&:not(.overflow) > *': {
          flexDirection: 'column',
        },
      },
      [mdUp]: {
        position: 'relative',
        height: 'calc(100% - 120px)',
        marginTop: 20,
        borderRadius: 16,
        boxShadow: '0px 16px 80px rgba(43, 67, 113, 0.15)',
        overflow: 'hidden',
        '&.frame': {
          height: '100%',
          marginTop: 0,
        },
      },
      '& > *': {
        height: '100%',
      },
    },
  };
});

const BoxContainer: React.FC<React.PropsWithChildren<BoxContainerProps>> = (props) => {
  const { children, maxWidth = 'md', variant = 'regular', overflow = false, frame = false } = props;
  const { classes, cx } = useStyles();
  return (
    <>
      <GlobalStyles
        styles={{
          html: {
            height: '100%',
          },
          body: {
            height: '100%',
            '& > *': {
              height: 'inherit',
            },
          },
        }}
      />
      <Container className={cx(classes.root, variant, { overflow, frame })} maxWidth={maxWidth} disableGutters>
        <Grid container>{children}</Grid>
      </Container>
    </>
  );
};

export default BoxContainer;
